/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const entityEntity = {

    entity: "entity",
    label: "Entity",

    fields: [

        {
            key: "entity_id",
            label: "ID",
            type: "uuid",
            visible: false,
            editable: false
        },

        {
            key: "entity_key",
            label: "Key",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "entity_name",
            label: "Name",
            type: "text",
            visible: true,
            editable: true
        },

        {
            key: "entity_type",
            label: "Type",
            type: "select",
            options: ["core", "domain", "system"],
            visible: true,
            editable: true
        },

        {
            key: "entity_status",
            label: "Status",
            type: "select",
            options: ["active", "inactive"],
            visible: true,
            editable: true
        },

        {
            key: "created_at",
            label: "Created",
            type: "datetime",
            visible: false,
            editable: false
        },

        {
            key: "updated_at",
            label: "Updated",
            type: "datetime",
            visible: false,
            editable: false
        }

    ]

}